module.exports = __webpack_public_path__ + "img/homeProduct03.97db2914.jpg";